import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from "sweetalert";

import { AgentDeletePreBookingRoom, AgentPropeortyBookingConfirm, GetAgentPreBookingRoomdetail, roomlistdetail } from '../Services/Service';
import AgentSidebar from './Commun/AgentSidebar';
import { AgentHeader } from './Commun/AgentHeader';

const AgentBookingconfirm = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [masterDetails, setMasterDetails] = useState({});
    const [roomDetails, setRoomDetails] = useState([]);
    const [tax, setTax] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalAfterTax, setTotalAfterTax] = useState(0);
    const [taxAmount, setTaxAmount] = useState(0);
    const [, setRooms] = useState([]);
    // const [editingRoomId, setEditingRoomId] = useState(null); // track which row is being edited
    // const [tempAmount, setTempAmount] = useState({});
    // const [roomAmount, setRoomAmount] = useState(0);



    useEffect(() => {
        const fetchBookingData = async () => {
            try {
                const result = await GetAgentPreBookingRoomdetail();
                console.log("Fetched booking data:", result);

                if (result?.MasterDetails?.length) {
                    setMasterDetails(result.MasterDetails[0]);
                }

                if (result?.RoomDetails?.length) {
                    setRoomDetails(result.RoomDetails);

                    // const amount = result.RoomDetails.reduce(
                    //   (acc, room) => acc + ((room.PerRoomRate || room.RoomRate || 0) + ((room.ExtraBed || 0) * (room.ExtraBedCharges || 0))),
                    //   0
                    // );

                    const amount = result.RoomDetails.reduce((acc, room) => {
                        const roomRate = room.RoomRate || room.PerRoomRate || 0;
                        const totalRoomCount = room.TotalRoom || 1;

                        // If API already gives ExtraBedAmount, use it
                        const extraBedTotal =
                            room.ExtraBedAmount !== undefined
                                ? room.ExtraBedAmount
                                : (room.ExtraBed || 0) * (room.ExtraBedCharges || 0);

                        return acc + totalRoomCount * roomRate + extraBedTotal;
                    }, 0);

                    console.log("ammount", amount);
                    setTotalAmount(amount);

                    // const taxPercent = result.TaxDetails?.[0]?.Tax || 0;
                    // setTax(taxPercent);

                    const taxPercent = amount < 7500 ? 5 : 18;
                    setTax(taxPercent);

                    const calculatedTaxAmount = (amount * taxPercent) / 100;
                    setTaxAmount(calculatedTaxAmount);

                    const afterTax = amount + calculatedTaxAmount;
                    setTotalAfterTax(afterTax);
                }
            } catch (err) {
                console.error("Failed to fetch booking data", err);
            }
        };

        fetchBookingData();
    }, []);


    const [formData, setFormData] = useState({
        Title: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        EmailAddress: "",
        Address: "",
        MobileNumber: "",
        Country: "",
        State: "",
        City: "",
        CompanyName: "",
        RegistrationNumber: "",
        RegistrationCompanyName: "",
        RegistrationCompanyAddress: "",
        BusSource: localStorage.getItem("AgentBusinessSource") || "",
        BillingInstruction: "",
        MarketSegment: localStorage.getItem("AgentMarketSegment") || "",
        guaranteeCodes: localStorage.getItem("AgentGuaranteeCodes") || "",
        BookingComment: "",
        PaymentComment: "",
    });


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            RegistrationNumber: localStorage.getItem("AgentGst") || "",
            RegistrationCompanyName: localStorage.getItem("AgentCompany") || "",
            RegistrationCompanyAddress: localStorage.getItem("AgentAddress") || "",
        }));
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const { Title, FirstName, LastName } = formData;

        if (!Title || !FirstName || !LastName) {
            swal("Please fill all guest details ", {
                icon: "warning",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-warning",
                    },
                },
            });
            setLoading(false);
            return;
        }

        const propertyID = localStorage.getItem("AgentPropertyID");

        const payload = {
            PreBookingToken: masterDetails?.PreBookingToken,
            TotalRoomRate: totalAmount,
            TotalExtraBedCharges: 0,
            TotalPayment: totalAmount,
            Tax: tax,
            TotalAfterTax: totalAfterTax,
            Discount: 0,
            PropertyID: propertyID,
            ...formData,
        };

        // console.log("booking data", payload);
        // console.log("Payload JSON:", JSON.stringify(payload, null, 2));


        try {
            await AgentPropeortyBookingConfirm(payload);

            swal("Your booking details submitted to Hotel!", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {

                localStorage.removeItem("AgentGuaranteeCodes");
                localStorage.removeItem("AgentMarketSegment");
                localStorage.removeItem("AgentBusinessSource");
                localStorage.removeItem("AgentCompany");
                localStorage.removeItem("AgentGst");
                localStorage.removeItem("AgentAddress");

                navigate("/Agent/Bookinglist", { state: { showSuccess: true } });
            });

        } catch (error) {
            swal("Booking Failed.", {
                icon: "error",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-danger",
                    },
                },
            });
        } finally {
            setLoading(false);
        }
    };


    const handleDeleteRoom = (roomId) => {
        if (!roomId) {
            alert("Missing Room ID.");
            return;
        }

        swal({
            title: "Are you sure?",
            buttons: {
                cancel: {
                    text: "Cancel",
                    visible: true,
                    className: "btn btn-danger",
                    closeModal: true,
                },
                confirm: {
                    text: "Yes, delete it!",
                    className: "btn btn-success",
                },
            },
            dangerMode: true,
        }).then(async (willDelete) => {
            if (!willDelete) return;

            setLoading(true);

            try {
                // Optionally call API to delete room on backend
                const result = await AgentDeletePreBookingRoom(roomId, masterDetails?.PreBookingToken);

                if (result?.PreBookingToken) {
                    // Remove room from local state only
                    const updatedRooms = roomDetails.filter(r => r.ID !== roomId);
                    setRoomDetails(updatedRooms);

                    // Recalculate total amount
                    const amount = updatedRooms.reduce(
                        (acc, r) => acc + (r.Amount !== undefined ? r.Amount : (r.TotalRoom * r.RoomRate + (r.ExtraBedAmount || 0))),
                        0
                    );
                    setTotalAmount(amount);

                    // Recalculate tax
                    const taxPercent = tax; // keep existing tax percent
                    const taxAmt = (amount * taxPercent) / 100;
                    setTaxAmount(taxAmt);
                    setTotalAfterTax(amount + taxAmt);

                    // Optional: alert user
                    // alert("Room deleted successfully");
                } else {
                    alert("Failed to delete room.");
                }
            } catch (error) {
                console.error("Error deleting room:", error);
                alert("Something went wrong while deleting the room.");
            } finally {
                setLoading(false);
            }
        });
    };



    // add room api 
    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const result = await roomlistdetail();
                if (result && Array.isArray(result)) {
                    setRooms(result);
                }
            } catch (err) {
                console.error("Error fetching rooms:", err);
            }
        };
        fetchRooms();
    }, []);

    // jab room change hoga → uske meal plans nikalenge
    // const handleRoomChange = (e) => {
    //     const roomId = e.target.value;
    //     const room = rooms.find((r) => r.RoomID.toString() === roomId);
    //     setSelectedRoom(room);

    //     if (room?.RatePlanDetails) {
    //         try {
    //             const parsedPlans = JSON.parse(room.RatePlanDetails);
    //             console.log("Parsed meal plans:", parsedPlans);
    //             setMealPlans(parsedPlans);
    //         } catch (err) {
    //             console.error("Error parsing RatePlanDetails:", err);
    //             setMealPlans([]);
    //         }
    //     } else {
    //         setMealPlans([]);
    //     }
    // };

    // const resetForm = () => {
    //     setSelectedRoom(null);
    //     setMealPlans([]);
    //     setSelectedMealPlan(null);
    //     setRoomAmount(0);
    //     setAdults("0");
    //     setChildren("0");
    //     setExtraBed("0");
    // };

    useEffect(() => {
        if (!roomDetails || !roomDetails.length) return;

        const newTotal = roomDetails.reduce((acc, r) => {
            const roomRate = Number(r.RoomRate || r.Amount || 0);
            const extraBed = Number(r.ExtraBedAmount || 0);
            const totalRoomCount = Number(r.TotalRoom || 1);
            return acc + totalRoomCount * roomRate + extraBed;
        }, 0);

        setTotalAmount(newTotal);

        const taxPercent = newTotal < 7500 ? 5 : 18;
        setTax(taxPercent);

        const calculatedTaxAmount = (newTotal * taxPercent) / 100;
        setTaxAmount(calculatedTaxAmount);

        setTotalAfterTax(newTotal + calculatedTaxAmount);
    }, [roomDetails]);


    return (
        <>
            <style> {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
      `}
            </style>

            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <AgentSidebar />
                <div className="main-panel">
                    <AgentHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card mb-0 ">
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">Agent Room Details</h4>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-2 mb-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label">Arrival:</label>
                                                            <input type="date" className="form-control" value={masterDetails?.CheckInDate?.split("T")[0] || ""} readOnly />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label">
                                                                Departure:
                                                            </label>
                                                            <input type="date" className="form-control" value={masterDetails?.CheckOutDate?.split("T")[0] || ""} readOnly />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label">
                                                                Rate Code:
                                                            </label>
                                                            <select className="form-control form-select" value={masterDetails?.RateCode || ''} disabled>
                                                                <option value="">{masterDetails?.RateCode || "Select Type"}</option>
                                                            </select>
                                                        </div>
                                                    </div>



                                                    {/*hotel rooom table */}

                                                    <div className="col-md-12">
                                                        <div className="table-responsive">

                                                            <table
                                                                className="display table  table-bordered "
                                                            // style={{
                                                            //   width: "100%",
                                                            //   whiteSpace: "nowrap",
                                                            // }}
                                                            >
                                                                <thead>
                                                                    <tr >
                                                                        <th className='th'> Room Type </th>

                                                                        <th>Rate Plan</th>
                                                                        <th> Meal Plan </th>
                                                                        {/* <th>  Rooms </th> */}
                                                                        <th style={{ width: "68px" }}> Adult</th>
                                                                        <th style={{ width: "68px" }}>Child</th>
                                                                        <th style={{ width: "111px" }}> Extra Bed's</th>
                                                                        <th className='text-center' > Amount </th>
                                                                        <th className='text-center'> Tax </th>
                                                                        <th className='text-center'> Net Amount </th>
                                                                        <th style={{ width: "83px" }}> Action </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {roomDetails.flatMap((room, roomIdx) =>
                                                                        Array.from({ length: room.TotalRoom || 1 }, (_, index) => (
                                                                            <tr key={`${roomIdx}-${index}`}>
                                                                                <td>{room.RoomName}</td>
                                                                                <td>{room.RatePlan}</td>
                                                                                <td>{room.MealPlan}</td>
                                                                                <td className='text-center'>{room.Adults}</td>
                                                                                <td className='text-center'>{room.Child}</td>
                                                                                <td className='text-center'>{room.ExtraBed}</td>


                                                                                <td className="text-center">
                                                                                    {room.RoomRate}

                                                                                    {/* <input
                                                                                        type="text"
                                                                                        readOnly={editingRoomId !== room.RoomID}
                                                                                        value={
                                                                                            editingRoomId === room.RoomID
                                                                                                ? tempAmount[room.RoomID] ?? room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                                                                                : room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                                                                        }
                                                                                        onChange={(e) => handleAmountInputChange(room.RoomID, e.target.value)}
                                                                                        className="form-control form-control-sm text-center me-2"
                                                                                        style={{ width: "100px", margin: "auto" }}
                                                                                    /> */}

                                                                                    {/* {editingRoomId === room.RoomID ? (
                                                                                        <div className="d-flex align-items-center gap-1">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn p-0 text-success"
                                                                                                onClick={() => handleSaveClick(room.RoomID)}
                                                                                                title="Save"
                                                                                            >
                                                                                                <i className="fas fa-check mx-3"></i>
                                                                                            </button>
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn p-0 text-danger"
                                                                                                onClick={handleCancelClick}
                                                                                                title="Cancel"
                                                                                            >
                                                                                                <i className="fas fa-times"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn p-0 "
                                                                                            onClick={() =>
                                                                                                handleEditClick(
                                                                                                    room.RoomID,
                                                                                                    room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                                                                                )
                                                                                            }
                                                                                            title="Edit"
                                                                                        >
                                                                                            <i className="fas fa-edit"></i>
                                                                                        </button>
                                                                                    )} */}

                                                                                </td>

                                                                                <td className='text-center'>{room.Tax}</td>
                                                                                <td className="text-center">
                                                                                    {(
                                                                                        parseFloat(room.RoomRate || 0) +
                                                                                        (parseFloat(room.RoomRate || 0) * parseFloat(room.Tax || 0) / 100)
                                                                                    ).toFixed(2)}
                                                                                </td>




                                                                                <td className='text-center'>
                                                                                    <button type='button' className=' btn py-0 px-1' style={{ color: "red" }} onClick={() => handleDeleteRoom(room.ID, masterDetails?.PreBookingToken)}><i className='fas fa-trash'></i></button>
                                                                                    {/* <button className='btn btn-danger btn-sm fas fa-trash' onClick={() => handleDeleteRoom(room.ID, masterDetails?.PreBookingToken)}>
                                              <i className='fas fa-trash me-2'></i>
                                            </button> */}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>


                                                    <div className="m-1 mt-4">
                                                        <div className="border bg-gray1 rounded-2 position-relative">
                                                            <h6
                                                                className="fw-bold position-absolute rounded-2"
                                                                style={{
                                                                    top: "-12px",
                                                                    paddingInline: "8px",
                                                                    backgroundColor: "#f5f7fd ",
                                                                    left: "5px",
                                                                }}
                                                            >
                                                                Total Amount{" "}
                                                            </h6>
                                                            <div className="row align-items-end p-3">
                                                                <div className="col-auto">
                                                                    <div className="input-block">
                                                                        <label className="col-form-label">
                                                                            Amount
                                                                        </label>
                                                                        <input type="number" className="form-control" value={totalAmount.toFixed(2)} readOnly />
                                                                    </div>
                                                                </div>

                                                                <div className="col-auto d-flex align-items-end pb-1">
                                                                    <span className="fw-bold fs-3">+</span>
                                                                </div>


                                                                <div className="col-auto">
                                                                    <div className="input-block">
                                                                        <div className="d-flex gap-2 mb-1">
                                                                            <label className="col-form-label">
                                                                                Tax Rate
                                                                            </label>
                                                                        </div>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={taxAmount.toFixed(2)}
                                                                            readOnly
                                                                        />
                                                                    </div>

                                                                </div>


                                                                <div className="col-auto d-flex align-items-end pb-1">
                                                                    <span className="fw-bold fs-3">=</span>
                                                                </div>

                                                                <div className="col-auto">
                                                                    <div className="input-block">
                                                                        <label className="col-form-label">
                                                                            Total Amount After Tax
                                                                        </label>
                                                                        <input type="text" className="form-control" value={totalAfterTax.toFixed(2)} readOnly />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* guest details table */}

                                                    <div className="col-md-12">
                                                        <h4 className="mt-3">Guest Details:</h4>
                                                        <div className="table-responsive">
                                                            <table
                                                                className="display table table-striped table-bordered table-hover"
                                                                style={{
                                                                    width: "100%",
                                                                    tableLayout: "auto",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>Title</th>
                                                                        <th>First Name</th>
                                                                        <th>Last Name</th>
                                                                        <th>Contact No </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <select className='form-select form-control' value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })}>
                                                                                <option>Select</option>
                                                                                <option>Mr.</option>
                                                                                <option>Mrs.</option>
                                                                                <option>Ms.</option>
                                                                                <option>Dr.</option>
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <input type="text" className="form-control" placeholder="Enter First Name" value={formData.FirstName} onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })} />
                                                                        </td>
                                                                        <td>
                                                                            <input type="text" className="form-control" placeholder="Enter Last Name" value={formData.LastName} onChange={(e) => setFormData({ ...formData, LastName: e.target.value })} />
                                                                        </td>
                                                                        <td>
                                                                            <input type="number" className="form-control" placeholder="Enter Contact No" value={formData.MobileNumber} onChange={(e) => setFormData({ ...formData, MobileNumber: e.target.value })} />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label">Email:</label>
                                                            <input type="email" className="form-control" placeholder="Enter Email" value={formData.EmailAddress} onChange={(e) => setFormData({ ...formData, EmailAddress: e.target.value })} />
                                                            <div className="form-check d-flex">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                <label className="form-check-label" htmlFor="flexCheckDefault"  >
                                                                    Do want to receive Booking Voucher on email ?
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-block">
                                                            <label className="col-form-label">Address</label>
                                                            <textarea
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Address"
                                                                value={formData.Address}
                                                                onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 ">
                                                        <div className="input-block">
                                                            <label className="col-form-label">City</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter City"
                                                                value={formData.City}
                                                                onChange={(e) => setFormData({ ...formData, City: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className="input-block">
                                                            <label className="col-form-label">Country</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Country"
                                                                value={formData.Country}
                                                                onChange={(e) => setFormData({ ...formData, Country: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className="input-block">
                                                            <label className="col-form-label">State</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter State"
                                                                value={formData.State}
                                                                onChange={(e) => setFormData({ ...formData, State: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className="input-block">
                                                            <label className="col-form-label">
                                                                Company Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Company Name"
                                                                value={formData.CompanyName}
                                                                onChange={(e) => setFormData({ ...formData, CompanyName: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="m-1 mt-4">
                                                        <div className="border bg-gray1 rounded-2 position-relative">
                                                            <h6
                                                                className=" fw-bold position-absolute bg-gray1 rounded-2"
                                                                style={{
                                                                    top: "-12px",
                                                                    left: "12px",
                                                                    paddingInline: "4px",
                                                                }}
                                                            >
                                                                Enter GST Details (Optional)
                                                            </h6>
                                                            <div className="row p-3">
                                                                <div className="col-md-4">
                                                                    <div className="input-block">
                                                                        <label className="col-form-label">
                                                                            Registration Number
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter Registration Number"
                                                                            value={formData.RegistrationNumber}
                                                                            onChange={(e) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    RegistrationNumber: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4">
                                                                    <div className="input-block">
                                                                        <label className="col-form-label">
                                                                            Registered Company Name
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter Registered Company Name"
                                                                            value={formData.RegistrationCompanyName}
                                                                            onChange={(e) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    RegistrationCompanyName: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4">
                                                                    <div className="input-block">
                                                                        <label className="col-form-label">
                                                                            Registered Company Address
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            placeholder="Registered Company Address"
                                                                            value={formData.RegistrationCompanyAddress}
                                                                            onChange={(e) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    RegistrationCompanyAddress: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">
                                                                Billing Instructions:
                                                            </label>
                                                            <select className="form-select form-control" value={formData.BillingInstruction}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, BillingInstruction: e.target.value })
                                                                }>
                                                                <option>Select Billing Instruction</option>
                                                                <option value="Pay at hotel">Pay at hotel</option>
                                                                <option value="Prepaid">Prepaid</option>
                                                                <option value="Send Invoice">Send Invoice</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label" htmlFor="marketSegment">
                                                                Market Segment
                                                            </label>
                                                            <select

                                                                className="form-select form-control"
                                                                value={formData.MarketSegment}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, MarketSegment: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {marketSegments &&
                                                                    marketSegments.map((item) => (
                                                                        <option key={item.ID} value={item.Code}>
                                                                            {item.MarketSeg}
                                                                        </option>
                                                                    ))}

                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">
                                                                Bus Source:
                                                            </label>
                                                            <select
                                                                className="form-select form-control"
                                                                value={formData.BusSource}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, BusSource: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {businessSources.map((item) => (
                                                                    <option key={item.ID} value={item.Code}>
                                                                        {item.BusinessSource}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-6">
                                                        <div className="ïnput-block mb-3">
                                                            <label className="col-from-lable">
                                                                Booking Comment
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                placeholder="Special Requriment"
                                                                value={formData.BookingComment}
                                                                onChange={(e) => setFormData({ ...formData, BookingComment: e.target.value })}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ïnput-block mb-3">
                                                            <label className="col-from-lable">
                                                                Payment Comment
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                placeholder="Payment Comment"
                                                                value={formData.PaymentComment}
                                                                onChange={(e) => setFormData({ ...formData, PaymentComment: e.target.value })}
                                                            ></textarea>
                                                        </div>
                                                    </div>

                                                    {/* <!-- Submit Button --> */}
                                                    <div className="card-action text-end">
                                                        <button type="submit" className="btn btn-black">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>

    );
};


export default AgentBookingconfirm;